import TableNoBorder from "../../../../components/tables/TableNoBorder";

const ModuleManagementTable = ({ ModuleData, resetFilterModule }) => {
  const columns = [
    {
      name: "User Id",
      cell: (row) => {
        return (
          <div className="w-full text-left">
            <div className="font-medium font-sans text-xs">{row.userId}</div>
          </div>
        );
      },
      sortable: true,
    },
    {
      name: "Module Id",
      cell: (row) => {
        return (
          <div className="w-full text-left">
            <div className="font-medium font-sans text-xs">{row.moduleId}</div>
          </div>
        );
      },
      sortable: true,
    },
    {
      name: "is Franchise",
      cell: (row) => {
        return (
          <div className="w-full text-left 2xl:mr-36">
            <input type="checkbox" checked={row.isFranchise} />
          </div>
        );
      },
      sortable: true,
    },
    {
      name: "View",
      cell: (row) => {
        return (
          <div className="w-full text-left 2xl:mr-36">
            <input type="checkbox" checked={row.isView} />
          </div>
        );
      },
      sortable: true,
    },
    {
      name: "Add",
      cell: (row) => {
        return (
          <div className="w-full text-left 2xl:mr-36">
            <input type="checkbox" checked={row.isAdd} />
          </div>
        );
      },
      sortable: true,
    },
    {
      name: "Edit",
      cell: (row) => {
        return (
          <div className="w-full text-left 2xl:mr-36">
            <input type="checkbox" checked={row.isEdit} />
          </div>
        );
      },
      sortable: true,
    },
    {
      name: "Delete",
      cell: (row) => {
        return (
          <div className="w-full text-left 2xl:mr-36">
            <input type="checkbox" checked={row.isDelete} />
          </div>
        );
      },
      sortable: true,
    },
  ];

  return (
    <div className="space-y-5">
      <TableNoBorder columns={columns} data={ModuleData} />
    </div>
  );
};

export default ModuleManagementTable;
